import React, {
  ChangeEvent,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Button,
  Card,
  CardHeader,
  Form,
  ListGroup,
  Modal,
} from "react-bootstrap";
import "react-simple-keyboard/build/css/index.css";
import ApplicationContext from "../../context/ApplicationContext";
import KeyboardWrapper from "../../helpers/KeyboardWrapper";
import { parkReceipt, updateReceipt } from "../../services/Service";
import { Message, MessageHeader } from "semantic-ui-react";
import { IPark } from "../../types/IPark";
import { generateGUID } from "../../helpers/Helper";

export interface ICustomParkProps {
  close(): void;
  success(): void;
  show: boolean;
}

export const CustomParkModal: React.FC<ICustomParkProps> = (
  props: ICustomParkProps
): JSX.Element => {
  const context = useContext(ApplicationContext);
  const [name, setName] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [invalidName, setInvalidName] = useState(false);

  const keyboard = useRef();

  const onKeyboardChange = (input: any) => {
    setName(input);
  };

  useEffect(() => {
    const table = context.Receipt.getTable();

    if (table !== undefined) {
      setName(table.description1);
    }
  }, []);

  const onNameChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const input = event.target.value;
    setName(input);
    // @ts-ignore
    keyboard.current.setInput(input);
  };

  const errorMessage = () => (
    <>
      <Message negative>
        <MessageHeader>Saving receipt failed</MessageHeader>
        <p>
          Please check your network (internet). If the error persist please
          contact support
        </p>
      </Message>
    </>
  );

  const nameInvalidMessage = () => (
    <>
      <Message negative>
        <MessageHeader>Saving receipt failed</MessageHeader>
        <p>Missing park details</p>
      </Message>
    </>
  );

  function close() {
    clear();
    props.close();
  }

  const customerModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => close()} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Customer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
              {hasError ? errorMessage() : <></>}
              {invalidName ? nameInvalidMessage() : <></>}

              <div
                style={{
                  height: "100%",
                  marginLeft: "auto",
                  marginRight: "0",
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                  paddingBottom: 20,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <Form.Control
                    placeholder={"name/ref/reg"}
                    aria-label="Name/ref/Reg"
                    aria-describedby="basic-addon1"
                    autoFocus={true}
                    style={{ fontSize: "20px", width: "100%" }}
                    value={name}
                    onChange={onNameChange}
                  />
                </div>
              </div>
              <div
                style={{
                  height: "100%",
                  marginLeft: "auto",
                  marginRight: "0",
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <KeyboardWrapper
                  keyboardRef={keyboard}
                  onChange={onKeyboardChange}
                  numKeys={false}
                />
              </div>
            </>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <div className="row">
              <div className="col">
                <Button
                  variant="primary"
                  style={{ width: 100, height: 50 }}
                  onClick={() => clear()}
                >
                  Clear
                </Button>{" "}
                <Button
                  variant="secondary"
                  onClick={() => props.close()}
                  style={{ width: 100, height: 50 }}
                >
                  Cancel
                </Button>
              </div>
            </div>
            <div className="mr-auto"></div>
            <div>
              <Button
                className="btn btn-success btn-lg"
                onClick={() => processPark()}
                style={{ width: 150, height: 50 }}
              >
                Park
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  async function processPark() {
    setIsSaving(true);
    setHasError(false);
    setInvalidName(false);

    if (name.length < 1) {
      setInvalidName(true);
      return;
    }

    const rows = context.Receipt.getRows();
    const table = context.Receipt.getTable();
    const rowsJson = JSON.stringify(rows);

    let success = false;

    if (table !== undefined) {
      const isSaved = await updateReceipt(
        context.AuthenticatedUser.getToken(),
        table.uuid,
        name,
        rowsJson
      );

      if (isSaved === true) {
        success = true;
      }
    } else {
      const iPark: IPark = {
        id: 0,
        uuid: generateGUID(),
        createdAt: new Date(),
        description1: name,
        description2: "",
        receiptData: "",
      };

      context.Receipt.setTable(iPark);

      const isSaved = await parkReceipt(
        context.AuthenticatedUser.getToken(),
        name,
        rowsJson
      );

      if (isSaved === true) {
        success = true;
      }
    }

    if (success === false) {
      setHasError(true);
      setIsSaving(false);
      return;
    }

    clear();
    props.success();
    setIsSaving(false);
  }

  function clear() {
    setName("");
    setIsSaving(false);
    setHasError(false);
    setInvalidName(false);
  }

  return (
    <>
      <>{customerModal()}</>
    </>
  );
};
